import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { ApiGoal, ApiGoalShort } from "@/types/goals.types.ts";

const SIDE_GOAL_PARAM = "sideGoal";

export function useGoalSidePanel() {
  const [searchParams, setSearchParams] = useSearchParams();

  const sideGoalId = searchParams.get(SIDE_GOAL_PARAM);
  const sideGoalIdNumber = sideGoalId ? parseInt(sideGoalId, 10) : null;

  const openGoalPanel = useCallback(
    (goal: ApiGoal | ApiGoalShort) => {
      setSearchParams((params) => {
        params.set(SIDE_GOAL_PARAM, goal.id.toString());
        return params;
      });
    },
    [setSearchParams]
  );

  const closeGoalPanel = useCallback(() => {
    setSearchParams((params) => {
      params.delete(SIDE_GOAL_PARAM);
      return params;
    });
  }, [setSearchParams]);

  return {
    sideGoalId: sideGoalIdNumber,
    isGoalPanelOpen: !!sideGoalId,
    openGoalPanel,
    closeGoalPanel,
  };
}
